<template>
    <div>
        <Word :word="word"/>
    </div>
</template>

<script>
    import Word from "@/components/dictionary/oxford/Word"

    export default {
        name: 'example',
        components: {
            Word
        },
        data: function () {
            return {
                word: 'work'
            }
        },
        async mounted() {
        }
    }
</script>
